import React from "react";
import { Container, Header, SubHeader } from "./styles";
import PropTypes from "prop-types";

const HeaderWithText = (props) => {
	const { header, text, showInTabletAndMobile } = props;
	return (
		<Container showInTabletAndMobile={showInTabletAndMobile}>
			<Header>{header}</Header>
			{text && (
				<SubHeader
					dangerouslySetInnerHTML={{
						__html: text,
					}}
				></SubHeader>
			)}
		</Container>
	);
};

HeaderWithText.propTypes = {
	header: PropTypes.string.isRequired,
	text: PropTypes.string,
	showInTabletAndMobile: PropTypes.bool,
};

HeaderWithText.defaultProps = {
	header: "",
	text: "",
	showInTabletAndMobile: true,
};

export default HeaderWithText;
